import './article-local-store-availability-short-info.scss';
import register from 'ShopUi/app/registry';import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('product-local-store-availability-short-info', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./product-local-store-availability-short-info')
    ),
);
